import { useTranslation } from "react-i18next";
import { Streamdown } from "streamdown";
import { LoginForm } from "./LoginForm";

export function LoginPage() {
  const { t } = useTranslation("auth");

  return (
    <div className="flex min-h-screen items-center justify-center overflow-y-auto bg-background p-4">
      <div className="w-full max-w-md space-y-6">
        {/* Logo */}
        <div className="text-center">
          <img
            src="/wapen-utrecht-rood.svg"
            alt="Gemeente Utrecht"
            className="mx-auto h-auto w-32"
          />
        </div>

        {/* Card with description */}
        <div className="bg-card p-8">
          {/* Description */}
          <div className="mb-6 text-sm text-foreground">
            <Streamdown
              components={{
                p: ({ children }: { children?: React.ReactNode }) => <>{children}</>,
                strong: ({ children }: { children?: React.ReactNode }) => (
                  <strong className="font-bold">{children}</strong>
                ),
              }}
            >
              {t("auth.login.description")}
            </Streamdown>
          </div>

          <LoginForm />
        </div>
      </div>
    </div>
  );
}
